import React, { memo } from 'react';
import custom from './IconClose.scss';

const SvgIcon = memo(({ children }) => (
  <svg
    //  as="svg"
    className={`${custom.Wrapper__SvgIcon} SvgIcon__icon`}
    focusable="false"
    role={'presentation'}
    aria-hidden={'true'}
    viewBox="0 0 30 30"
    //  aria-label={accessibleTitle}
    size={'14'}
    color={'currentColor'}
  >
    {children}
  </svg>
));

const IconClose = props => (
  <SvgIcon {...props} iconType="functional">
    <path d="M27 26.9999L3 2.9999" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 26.9999L27 2.9999" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

export default IconClose;
